import { useEffect } from 'react';
import { AlertTriangleIcon, PencilIcon, RotateCcwIcon } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import type { ChatTurnErrorState } from '../chat-turn-error';
import { countChatUxEvent } from '../chat-ux-metrics';

type ChatTurnErrorProps = {
  error: ChatTurnErrorState;
  onEdit?: () => void;
  onRetry: () => void;
};

export function ChatTurnError({ error, onEdit, onRetry }: ChatTurnErrorProps) {
  useEffect(() => {
    countChatUxEvent('chat.ui.stream_error_inline_shown');
  }, []);

  return (
    <Alert
      className="max-w-[min(100%,48rem)] border-destructive/30 bg-destructive/5"
      data-testid="chat-turn-error"
      variant="destructive"
    >
      <AlertTriangleIcon />
      <AlertTitle>
        {error.hasPartialResponse ? 'Réponse interrompue' : 'La réponse n’a pas pu être générée'}
      </AlertTitle>
      <AlertDescription className="flex flex-col gap-3">
        <p>{error.message}</p>
        <div className="flex flex-wrap gap-2">
          {error.retryable ? (
            <Button
              data-testid="chat-turn-retry"
              onClick={onRetry}
              size="sm"
              type="button"
              variant="outline"
            >
              <RotateCcwIcon data-icon="inline-start" />
              Réessayer
            </Button>
          ) : null}
          {onEdit ? (
            <Button
              data-testid="chat-turn-edit"
              onClick={onEdit}
              size="sm"
              type="button"
              variant="ghost"
            >
              <PencilIcon data-icon="inline-start" />
              Modifier le message
            </Button>
          ) : null}
        </div>
      </AlertDescription>
    </Alert>
  );
}
